import React, { useEffect, useState } from 'react';
import { Paper, Grid, Box, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import Face3Icon from '@mui/icons-material/Face3';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import HomeIcon from '@mui/icons-material/Home';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SecurityIcon from '@mui/icons-material/Security';
import NotesIcon from '@mui/icons-material/Notes';
import AppointmentDetailTabs from './AppointmentDetailTabs';
import { getDecryptedAccessToken, getDecryptedUserType } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import { useParams } from 'react-router-dom';
import ApiServices from '../../../Utils/ApiServices/ApiServices';
import HealingIcon from '@mui/icons-material/Healing';

const AppointmentDetails = ({appointmentData}) => {
  const accessToken = getDecryptedAccessToken();
  const LoginUserType = getDecryptedUserType();
  const params = useParams();
  // const [appointmentData, setAppointmentData] = useState(null);

  // useEffect(() => {
  //   const fetchAppointmentDetails = async () => {
  //     try {
  //       const apiUrl = LoginUserType === 'Patient' 
  //         ? `/apis/default/portal/appointment/${params.eid}` 
  //         : `/apis/default/api/appointment/${params.eid}`;

  //       const response = await ApiServices.get(apiUrl, {
  //         Authorization: `Bearer ${accessToken}`
  //       });

  //       setAppointmentData(response.data[0]);
  //     } catch (error) {
  //       console.error("Error fetching appointment details:", error);
  //     }
  //   };

  //   if (params.eid) {
  //     fetchAppointmentDetails();
  //   }
  // }, [params.eid, LoginUserType, accessToken]);

  return (
    <div>
      {appointmentData && (
        <Paper
          elevation={3}
          sx={{
            padding: '20px',
            background: 'linear-gradient(135deg, #012A4A 0%, #025E73 35%, #028391 65%, #03A9A3 100%)',
            color: 'white',
            borderRadius: '8px',
            marginBottom: '20px'
          }}
        >
          <Grid container spacing={3} alignItems="center">
            {/* 1. Avatar */}
            <Grid item xs={12} sm={1} display="flex" justifyContent="center">
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'white',
                  borderRadius: '50%',
                }}
              >
              
                  <HealingIcon sx={{ fontSize: 60, color: '#D81B60' }} />
                
              </Box>
            </Grid>


            {/* 3. Appointment Details */}
            <Grid item xs={12} sm={3} sx={{ textAlign: 'left' }}>
              <Typography variant="body2">
                <CalendarTodayIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Appointment Date:</strong> {appointmentData.pc_eventDate || 'N/A'}
              </Typography>
              <Typography variant="body2">
                <AccessTimeIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Time:</strong> {appointmentData.pc_startTime || 'N/A'}
              </Typography>
              <Typography variant="body2">
                <HomeIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Appointment Type:</strong> {appointmentData.appointment_type || 'N/A'}
              </Typography>
            </Grid>

            {/* 4. Contact Details */}
            {LoginUserType !== 'Patient' && (
            <Grid item xs={12} sm={3} sx={{ textAlign: 'left' }}>
              <Typography variant="body2">
                <EmailIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Patient:</strong>  {appointmentData.patient_fname} {appointmentData.patient_lname}
              </Typography>
              <Typography variant="body2">
                <EmailIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Email:</strong> {appointmentData.patient_email || 'N/A'}
              </Typography>
              <Typography variant="body2">
                <PhoneIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Phone:</strong> {appointmentData.patient_contact || 'N/A'}
              </Typography>
            </Grid>)}

            {/* 5. Appointment Status */}
            <Grid item xs={12} sm={2} sx={{ textAlign: 'left' }}>
              <Typography variant="body2">
                <AssignmentIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Appointment Status:</strong> {appointmentData.pc_apptstatus || 'N/A'}
              </Typography>
              <Typography variant="body2">
                <MonetizationOnIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Billed:</strong> {appointmentData.is_billed ? '✔ Yes' : '❌ No'}
              </Typography>
              <Typography variant="body2">
                <SecurityIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                <strong>Provider:</strong> {appointmentData.provider_fname} {appointmentData.provider_lname}
              </Typography>
            </Grid>

            {/* 6. SOAP Note (Only for Non-Patients) */}
            {LoginUserType !== 'Patient' && (
              <Grid item xs={12} sm={3} sx={{ textAlign: 'left' }}>
                <Typography variant="body2">
                  <NotesIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                  <strong>SOAP Note:</strong>
                </Typography>
                <Typography variant="body2" sx={{ ml: 4 }}>
                  {appointmentData.soap_note || 'N/A'}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Paper>
      )}

      {/* Appointment Details Tabs */}
      <AppointmentDetailTabs appointmentData={appointmentData}/>
    </div>
  );
};

export default AppointmentDetails;
